<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()" >
          <a class="anchor" id="blocqualifelec"></a>

    <v-card elevation="2">
      <v-card-title>Certification QualifElec</v-card-title>
      <v-card-text>
        <a href="https://www.qualifelec.fr/rechercher/" target="_blank">
          <img
              title="Entreprise certifiée QualifElec" src="../../assets/logo_qualifelec.png"
          />
        </a>
        <v-row>
          <v-col cols="7">
            <v-simple-table>
              <thead>
              <tr>
              <th class="text-left">Qualifications</th>
              <th class="text-left">Effectifs</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in qualifications" :key="item.codeQualif">
                <td>
                  {{ item.libQualif }} ({{ item.codeQualif }})
                </td>
                <td>
                  {{ item.classe }}
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col cols="5">
            <v-card-subtitle>{{ (this.certificats == null ? 0 :  this.certificats.length) }} Certificats</v-card-subtitle>
            <v-template v-for="(item,i) in certificats" :key="i">
              <a :href="item" target="_blank">
                <v-chip
                    class="ma-2"
                    color="grey"
                    text-color="white"
                >
                  <v-avatar left>
                    <v-icon>mdi-file-pdf</v-icon>
                  </v-avatar>
                  <span>Certif n°{{ i + 1 }}</span>
                </v-chip>
              </a>


            </v-template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>

export default {
  name: "QualifElec",
  props: [""],
  components: {},
  computed: {


    qualifications: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualifelec_qualifications", null, "valeur");
    },
    certificats: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualifelec_certificats", null, "valeur");
    },
  },
  methods: {
    condition() {
      return this.$store.getters.condition("certificats", "donnees", "qualifelec_certificats", "valeur");
    },
  },
};
</script>
